import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthProvider } from "../customHooks/authContext";

function ProtectedRoute({ children, allowedRoles = [] }) {
  const { isAuthenticated, role } = useAuthProvider();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.some(r => role.includes(r))) {
    // Si el usuario no tiene ninguno de los roles requeridos, redirecciona
    return <Navigate to="/members" replace />;
  }

  return children;
}

export default ProtectedRoute;
